import { format, isValid, parse } from 'date-fns';

// The value format of FlatpickrDatePickerComponent's default 'Y/m/d'
const PICKER_DATE_FORMAT = 'yyyy/MM/dd';

const API_DATE_FORMAT = 'yyyy-MM-dd';

export function parsePickerDate(value: string | null | undefined): Date | null {
  if (!value) {
    return null;
  }

  const date = parse(value, PICKER_DATE_FORMAT, new Date());
  return isValid(date) ? date : null;
}

export function formatPickerDate(date: Date): string {
  return format(date, PICKER_DATE_FORMAT);
}

/**
 * The picked calendar day as a date-only string. Sending a Date instead serialises local midnight as UTC,
 * which lands on the previous day for anyone east of UTC.
 */
export function toApiDate(value: string): string {
  const date = parsePickerDate(value);
  return date ? format(date, API_DATE_FORMAT) : value;
}
